import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted, {
  position: 'bottom-right',
  theme: 'bubble',
  duration: 3000
})
